<template>
  <td :class="{dimmed: isBeforePush}">
    <template v-if="isBeforePush">{{$utils.timeText(newsData.reserveDate)}}</template>
    <template v-else>{{$utils.timeText(newsData.pushFirstDate)}}</template>
  </td>
</template>

<script>
export default {
  props: {
    newsData: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    isBeforePush() {
      const isReserve = this.newsData.pushType === 'RESERVE';
      const status = this.newsData.pushStatus;
      const isWait = status === 'WAIT' || status === 'RESEND_WAIT'
      return isReserve && isWait;
    }
  }
};
</script>

<style scoped>
.dimmed {
  color: #0387ca;
}
</style>